"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExercisePagination = void 0;
const react_1 = __importDefault(require("react"));
const Pagination_1 = require("@components/Pagination");
function ExercisePagination({ answersFrameArray, }) {
    return (react_1.default.createElement(Pagination_1.Pagination, null, answersFrameArray.map((item) => (react_1.default.createElement(Pagination_1.PaginationItem, { key: item.id, item: item })))));
}
exports.ExercisePagination = ExercisePagination;
